import React from 'react';

type CarouselSectionProps = {
  ariaLabel: string;
  currentIndex: number;
  onSelect: (index: number) => void;
  slides: Array<{ src: string; alt: string }>;
  sectionId?: string;
};

function CarouselSection({
  ariaLabel,
  currentIndex,
  onSelect,
  slides,
  sectionId,
}: CarouselSectionProps) {
  return (
    <section
      className="brand-section brand-carousel-section"
      aria-label={ariaLabel}
      data-page-section={sectionId}
    >
      <div
        className="brand-carousel-track"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((section, index) => (
          <div className="brand-carousel-slide" key={section.alt}>
            <img
              className={`brand-carousel-image${index === currentIndex ? ' is-active' : ''}`}
              src={section.src}
              alt={section.alt}
            />
          </div>
        ))}
      </div>

      <div className="brand-carousel-dots">
        {slides.map((section, index) => (
          <button
            aria-label={`查看 ${section.alt}`}
            className={`brand-carousel-dot${index === currentIndex ? ' is-active' : ''}`}
            key={section.alt}
            type="button"
            onClick={() => onSelect(index)}
          />
        ))}
      </div>
    </section>
  );
}

export default CarouselSection;
